module.exports = __webpack_public_path__ + "static/showroom1-51fe3aa0149fd3a1dce5ebec737e80a8.jpg";